module.exports = __webpack_public_path__ + "img/bg-magento-find-out_medium@2x.d890e996.jpg";